// extracted by mini-css-extract-plugin
module.exports = {"toast":"notifications_toast__fpmga","customToastSuccess":"notifications_customToastSuccess__3U0zT","toastIconSuccess":"notifications_toastIconSuccess__29Sh1"};